
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-lines",
      function () {
        return require("private-next-pages/product-lines.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-lines"])
      });
    }
  